/**
 * OtpVerifyForm - OTP verification form
 */
import React from 'react';
import { useAuthContext } from '../../context/AuthContext';
import { useAuth } from '../../hooks/useAuth';
import { useAuthForm } from '../../hooks/useAuthForm';
import { INPUT_TYPES } from '../../types';
import { AuthHeader, AuthButton, OtpInput, ResendOtp } from '../ui';

function OtpVerifyForm() {
  const { 
    identifier, 
    identifierType, 
    loading, 
    goBack,
  } = useAuthContext();
  
  const { verifyOtp, resendOtp } = useAuth();
  const { otp, error, handleOtpChange, isOtpValid } = useAuthForm();
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!isOtpValid()) return;
    
    await verifyOtp();
  };
  
  // Mask identifier for display
  const maskedIdentifier = identifierType === INPUT_TYPES.MOBILE
    ? `******${identifier.slice(-4)}`
    : identifier.replace(/(.{3})(.*)(@.*)/, '$1***$3');
  
  return (
    <div className="relative p-6 md:p-8 bg-white">
      <AuthHeader
        title="Verify OTP"
        subtitle={`Enter the 6-digit code sent to ${maskedIdentifier}`}
        showBack
        onBack={goBack}
      />
      
      <form onSubmit={handleSubmit} className="space-y-6">
        <OtpInput
          value={otp}
          onChange={handleOtpChange}
          error={error}
          disabled={loading}
          autoFocus
        />
        
        <AuthButton
          type="submit"
          loading={loading}
          disabled={!isOtpValid()}
        >
          Verify & Continue
        </AuthButton>
        
        <ResendOtp onResend={resendOtp} disabled={loading} />
      </form>
      
      {/* Edit contact */}
      {/* <div className="mt-6 text-center">
        <button
          type="button"
          onClick={goBack}
          className="text-sm text-gray-500 hover:text-[#004171] transition-colors"
        >
          Wrong {identifierType === INPUT_TYPES.MOBILE ? 'number' : 'email'}? 
          <span className="font-medium text-[#004171] ml-1">Edit</span>
        </button>
      </div> */}
    </div>
  );
}

export default OtpVerifyForm;
